import React from 'react';

interface ContentIntegratorProps {
    readonly contentUrl: string;
    readonly cta: React.ReactNode;
}

export const ContentIntegrator: React.FC<ContentIntegratorProps> = ({ contentUrl, cta }) => {
    return (
        <div className="relative h-full w-full font-poppins text-grey">
            <iframe src={contentUrl} className="absolute h-full w-full"></iframe>
            {cta}
        </div>
    );
};
